module.exports = __webpack_public_path__ + "static/media/HND.7c7dda26.svg";